import { Ambulance, List, Time } from '../../../Assets/SVGS'
import Icon from '../../common/Icon/Icon'
import './ThreeCards.css'
import { useTranslation } from 'react-i18next';
function ThreeCards(){
  const { t } = useTranslation();
  return(
    <div className="threeCards-container container">
      <div className="threeCards-content">
        <div className="card">
          <h3>{t('emergencyCases')}</h3>
          <p>{t('emergencyCasesDesc')}</p>
          <button>{t('learnMore')}</button>
          <Icon icon={<Ambulance width="100px"/>}/>
        </div>
        <div className="card">
          <h3>{t('openingHours')}</h3>
          <p>{t('openingHoursDesc')}</p>
          <button>{t('learnMore')}</button>
          <Icon icon={<List width="100px"/>}/>
        </div>
        <div className="card">
          <h3>{t('openingHours')}</h3>
          <p>{t('openingHoursDesc')}</p>
          <button>{t('learnMore')}</button>
          <Icon icon={<Time width="100px"/>}/>
        </div>
      </div>
    </div>
  )
}
export default ThreeCards